import { action } from "@ember/object"
import Component from "@glimmer/component"

interface Options {
  nameOfNewTeam: string | null
}

interface Sig {
  Args: {
    options: Options
    accept: (nameOfNewTeam: string) => void
    decline: () => void
  }
}

export default class AskForTeamTitle extends Component<Sig> {
  @action
  onKeydown(event: KeyboardEvent) {
    if (event.key === "Enter") {
      event.stopPropagation()
      if (this.args.options.nameOfNewTeam) this.args.accept(this.args.options.nameOfNewTeam)
    }
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Dialogs::AskForTeamTitle": AskForTeamTitle
  }
}
